export default "__VITE_ASSET__BVfqPaOT__"